var map = {
	"./analytics_tracker_controller.js": 83196,
	"./application_controller.js": 61788,
	"./category_favorites_controller.js": 30341,
	"./coin_favorites_controller.js": 49374,
	"./feature_flag_controller.js": 14900,
	"./generic_chart_controller.js": 75555,
	"./load_sentry_controller.js": 79063,
	"./mixpanel_init_controller.js": 51656,
	"./more_content_controller.js": 25034,
	"./nft_favorites_controller.js": 65209,
	"./nft_portfolio_nfts_modal_controller.js": 82382,
	"./percent_change_controller.js": 65589,
	"./pie_chart_controller.js": 83238,
	"./portfolio_coins_modal_controller.js": 4936,
	"./portfolio_modal_controller.js": 58079,
	"./price_chart_controller.js": 71683,
	"./price_controller.js": 46058,
	"./remove_element_controller.js": 89702,
	"./settings_controller.js": 16280,
	"./simple_countdown_controller.js": 59905,
	"./stacked_chart_controller.js": 51854,
	"./toaster_controller.js": 37277,
	"./tooltips_controller.js": 43490,
	"controllers_v2/global/analytics_tracker_controller.js": 83196,
	"controllers_v2/global/application_controller.js": 61788,
	"controllers_v2/global/category_favorites_controller.js": 30341,
	"controllers_v2/global/coin_favorites_controller.js": 49374,
	"controllers_v2/global/feature_flag_controller.js": 14900,
	"controllers_v2/global/generic_chart_controller.js": 75555,
	"controllers_v2/global/load_sentry_controller.js": 79063,
	"controllers_v2/global/mixpanel_init_controller.js": 51656,
	"controllers_v2/global/more_content_controller.js": 25034,
	"controllers_v2/global/nft_favorites_controller.js": 65209,
	"controllers_v2/global/nft_portfolio_nfts_modal_controller.js": 82382,
	"controllers_v2/global/percent_change_controller.js": 65589,
	"controllers_v2/global/pie_chart_controller.js": 83238,
	"controllers_v2/global/portfolio_coins_modal_controller.js": 4936,
	"controllers_v2/global/portfolio_modal_controller.js": 58079,
	"controllers_v2/global/price_chart_controller.js": 71683,
	"controllers_v2/global/price_controller.js": 46058,
	"controllers_v2/global/remove_element_controller.js": 89702,
	"controllers_v2/global/settings_controller.js": 16280,
	"controllers_v2/global/simple_countdown_controller.js": 59905,
	"controllers_v2/global/stacked_chart_controller.js": 51854,
	"controllers_v2/global/toaster_controller.js": 37277,
	"controllers_v2/global/tooltips_controller.js": 43490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98795;